export default {
  maintenaceSlogan: 'Kami akan segera kembali!',
  maintenanceMessage:
    'Kami saat ini sedang melakukan pemeliharaan terjadwal untuk meningkatkan layanan kami kepada Anda. Kami mohon maaf atas ketidaknyamanannya dan menghargai kesabaran Anda. Silakan cek kembali nanti',
  maintenanceAction: 'Butuh bantuan?',
  linkToDiscord: 'Hubungi tim dukungan kami',
}
